import {useNavigate, useSearchParams} from "react-router-dom";
import React from "react";
import {doFetch} from "../../../util/fetch";
import SvgLoader from "../../../svg/SvgLoader";
import SvgDiscord from "../../../svg/SvgDiscord";
import {useAuth} from "../contexts/AuthContext";

export function getLoginRedirectUrl(continueLocation?: string){
    const url = new URL("/r/discord-login", window.location.origin);
    if (continueLocation){
        url.searchParams.set("continue", continueLocation)
    }
    return url.toString()
}

export default function Login(){

    const auth = useAuth()
    const navigate = useNavigate()
    const [search] = useSearchParams()
    const action = search.get("do")

    const signInWithDiscord = () => {
        if (auth.isLoggedIn){
            navigate('/login?msg=logged_in')
        }
        else{
            window.location.assign(getLoginRedirectUrl())
        }
    }

    if (action === "logout"){
        doFetch(`/api/client/auth/logout`).then(r => {
            if (r.ok){
                // Don't use navigate here, we have to reload the page
                window.location.replace("/login?msg=logout_success")
            }
            else{
                navigate("/login?err=logout_error")
            }
        })

        return <div>
            <div className="bg-neutral-800 rounded-md m-4 py-4 px-8 flex items-center">
                <SvgLoader />
                <span className="ms-8 text-lg font-bold">Signing out ...</span>
            </div>
        </div>
    }

    return <div className="p-4 flex flex-col items-center justify-between flex-1 pb-24">
        <div className="max-w-5xl h-full">
            <div className="flex flex-col items-center justify-center h-full gap-8">
                <div className="flex flex-col items-center gap-3">
                    <img src="/android-chrome-512x512.png" className="w-12 h-12 rounded-md" alt="Logo" />
                    <h1 className="text-center text-2xl font-semibold" >Sign in to Rust Server Tool</h1>
                </div>

                <div className="bg-neutral-900 border-neutral-500 border px-8 py-6 md:py-8 md:px-16 rounded-md shadow-md flex gap-8">
                    <button onClick={signInWithDiscord}
                            className="w-full flex items-center justify-center bg-discord text-discord-light py-2 px-4 md:px-8 rounded hover:opacity-90 gap-4">
                        <SvgDiscord />
                        <span className="">Continue with Discord</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
}